import { useEffect, useState, useContext } from "react"
import ApiContext from "src/provider/API/call-service"
import { 
    SidePopupContainer, FlexColumn, Button, 
    Form, FormGroup, FlexRow, AppSpan, CustomContainer, AppText
} from "src/style"
import { RiCloseFill } from "react-icons/ri"
import utility, { handleTypeNumberControl } from 'src/utils/utility'

export const Add_Edit_Fee: React.FC<any> = ({getFees, rowData, isEdit, close}) => {
    const {API} = useContext(ApiContext)
    const [input, setInput] = useState<any>({
        name: '', lowerBound: '', upperBound: '', 
        fixedFee: '', percentageFee: '', minimumFee: '',
        maximumFee: '', qorePercentage: '', serviceProviderPercentage: ''
    })

    useEffect(() => {
        if (rowData && isEdit) {
            const {
                name, lowerBound, upperBound, 
                fixedFee, percentageFee, minimumFee, 
                maximumFee, qorePercentage, serviceProviderPercentage
            } = rowData

            setInput({
                ...input, name, 
                lowerBound: lowerBound * 100, 
                upperBound: upperBound * 100, 
                fixedFee: fixedFee * 100, 
                percentageFee: percentageFee * 100,
                minimumFee: minimumFee * 100, 
                maximumFee: maximumFee * 100,
                qorePercentage: qorePercentage * 100, 
                serviceProviderPercentage: serviceProviderPercentage * 100
            })
        }
    }, [rowData])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.name === 'name') {
            setInput({...input, [e.target.name]: e.target.value})
        }
        else {
            let val = e.target.value.replace(/[,.]/g, '')
            let name = e.target.name
            if (!isNaN(Number(val))) {
                const percentageFields = ['qorePercentage', 'serviceProviderPercentage', 'percentageFee']
                if (percentageFields.includes(name) && Number(val) > 10000) return null
                
                if (['qorePercentage', 'serviceProviderPercentage'].includes(name)) {
                    if (name === 'qorePercentage') {
                        setInput({...input, [name]: val, serviceProviderPercentage: 10000 - Number(val)})
                    }
                    else if (name === 'serviceProviderPercentage') {
                        setInput({...input, [name]: val, qorePercentage: 10000 - Number(val)})
                    }
                }
                else setInput({...input, [name]: val})
            }
        }
    }

    async function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        const payload = utility.getActualKoboValue(input)
        const response = isEdit ? 
            await API.UpdateFee(rowData.id, payload)
            : await API.CreateFee(payload)
        
        if (response && getFees) {
            getFees()
            close()
        }
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">{rowData ? 'Edit Fee' : 'Create New Fee'}</AppSpan>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </FlexRow>
                <Form onSubmit={handleSubmit} topMargin='2'>
                    <FormGroup>
                        <label>Fee Name</label>
                        <input 
                            placeholder="Enter fee name" 
                            name='name'
                            value={input.name}
                            onChange={handleInput}
                            required={!isEdit}
                        />
                    </FormGroup> 
                    <FlexRow 
                        justifyContent='space-between' gap='2'
                        className='filter-input-row multiple-row-inputs'
                    >
                        <FormGroup bottomMargin='0'>
                            <label>Lower bound</label>
                            <input 
                                placeholder="Enter value"
                                name='lowerBound'
                                value={input.lowerBound ? utility.koboFormat(input.lowerBound) : ''}
                                onChange={handleInput}
                                autoComplete="off"
                                required={!isEdit}
                            />
                        </FormGroup>
                        <FormGroup bottomMargin='0'>
                            <label>Upper bound</label>
                            <input 
                                placeholder="Enter value" 
                                name='upperBound'
                                value={input.upperBound ? utility.koboFormat(input.upperBound) : ''}
                                onChange={handleInput}
                                autoComplete="off"
                                required={!isEdit}
                            />
                        </FormGroup>
                    </FlexRow>
                    <FormGroup>
                        <label>Fixed charge</label>
                        <input 
                            placeholder="Enter fixed charge" 
                            name='fixedFee'
                            value={input.fixedFee ? utility.koboFormat(input.fixedFee) : ''}
                            onChange={handleInput}
                            required={!isEdit}
                        />
                    </FormGroup>  
                    <FormGroup>
                        <label>Percentage charge</label>
                        <input 
                            placeholder="Enter percentage" 
                            name='percentageFee'
                            value={input.percentageFee ? utility.koboFormat(input.percentageFee) : ''}
                            onChange={handleInput}
                            required={!isEdit}
                        />
                    </FormGroup>  
                    { input.percentageFee &&
                        <FlexRow 
                            justifyContent='space-between' gap='2'
                            className='filter-input-row multiple-row-inputs'
                        >
                            <FormGroup bottomMargin='0'>
                                <label>Minimum % charge</label>
                                <input 
                                    placeholder="Enter percent" 
                                    name='minimumFee'
                                    value={input.minimumFee ? utility.koboFormat(input.minimumFee) : ''}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                            <FormGroup bottomMargin='0'>
                                <label>Maximum % charge</label>
                                <input 
                                    placeholder="Enter percent" 
                                    name='maximumFee'
                                    value={input.maximumFee ? utility.koboFormat(input.maximumFee) : ''}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                        </FlexRow>
                    }
                    
                    <CustomContainer>
                        <AppText 
                            color='#344054' fontWeight="600"
                            bottomPadding="1"
                            style={{borderBottom: '1px solid #EAECF0'}}
                        >
                            Percentage Split
                        </AppText>
                        <FlexRow 
                            justifyContent='space-between' gap='2' topMargin="2"
                            className='filter-input-row multiple-row-inputs'
                        >
                            <FormGroup bottomMargin='0'>
                                <label>Qore Fee</label>
                                <input 
                                    placeholder="Enter percentage" 
                                    name='qorePercentage'
                                    value={input.qorePercentage ? utility.koboFormat(input.qorePercentage) : ''}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                            <FormGroup bottomMargin='0'>
                                <label>Service Provider Fee</label>
                                <input 
                                    placeholder="Enter percentage" 
                                    name='serviceProviderPercentage'
                                    value={input.serviceProviderPercentage ? utility.koboFormat(input.serviceProviderPercentage) : ''}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                        </FlexRow>
                    </CustomContainer>
                    
                    <FlexRow justifyContent='flex-end'>
                        <Button
                            width='8.1'
                            titleSize='1.4' fontWeight="500"
                            height='4' radius='0.8'
                            bottomMargin='1' hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                        >
                            Submit
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </>
    )
}